// --- 账户管理 --- //

export default [
  {
    name: 'accountNumManagement',
    path: '/platformManagement/accountManagement/accountNumManagement',
    meta: { title: '账号管理' },
    component: require('business/platformManagement/accountManagement/accountNumManagement/list.vue').default
  },
  {
    name: 'roleManagement',
    path: '/platformManagement/accountManagement/roleManagement',
    meta: { title: '角色管理' },
    component: require('business/platformManagement/accountManagement/roleManagement/list.vue').default
  }
]
